import { RedoPrintJobSchema } from "@redotech/redo-fulfillment-group-common/print-job";
import * as z from "zod";

const PrintQueueJobSchema = RedoPrintJobSchema.and(
  z.object({ batchNumber: z.string().optional() }),
);

export const PrintQueueStatusSchema = z.object({
  total: z.number(),
  completed: z.number(),
  failed: z.array(PrintQueueJobSchema),
  inFlight: z.array(PrintQueueJobSchema),
  activeJob: PrintQueueJobSchema.nullish(),
});

export type PrintQueueStatus = z.infer<typeof PrintQueueStatusSchema>;
